import data from "../../../../../src/SelectPanel/SelectPanel.docs.json";
import * as React from 'react';
export default {
  data,
  React
};